import { useState, useEffect } from 'react';
import gun from '../config/gun.config';

const SEEN_KEY = 'stabeon_notif_seen_ts';
const getSeenTs = () => parseInt(localStorage.getItem(SEEN_KEY) || '0', 10);

export function useNotifUnreadCount(userId: string | null): number {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!userId) return;
    const node = gun.get('joystance_notifications').get(userId);
    const incoming: Record<string, number> = {};

    const mapNode = node.map();
    mapNode.on((data: any, id: string) => {
      if (!data || !data.ts || !id) return;
      incoming[id] = data.ts;
      const seenTs = getSeenTs();
      const unread = Object.values(incoming).filter(ts => ts > seenTs).length;
      setCount(unread);
    });

    return () => { try { mapNode.off(); } catch {} };
  }, [userId]);

  return count;
}
